import React, {FC} from "react"

import {Body, H1} from "@irati/ui/src/Typography"
import {useTheme} from "@irati/ui/src/global/useTheme"
import Loading from "@irati/ui/src/Loading"
import FormattedMessage from "@irati/utils/lang"
import {hangPromise} from "@irati/utils/promise"

import Spinner from "@irati/ui/src/Loading/Spinner"
import {StyledCard} from "../styled"

interface Props {
  title?: string
}

const ReviewingYourDetails: FC<Props> = ({title = "platform.selfSignUp.reviewingDetails.title"}) => {
  const theme = useTheme()
  return (
    <StyledCard maxWidth="600px" marginTop="50px">
      <H1 color={theme.colors.primary2} textAlign="center">
        <FormattedMessage id={title} />
      </H1>
      <Loading load={hangPromise()} Loader={() => <Spinner size="lg" />} />
      <Body large color={theme.colors.primary2} textAlign="center">
        <FormattedMessage id="platform.selfSignUp.reviewingDetails.subTitle" />
      </Body>
    </StyledCard>
  )
}

export default ReviewingYourDetails
